import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';

import { AdditionalProgramState } from '../models/programsGeneric';
import { getAdditionalPrograms } from '../selectors/programsSelectors';
import { AdditionalProgramCard } from './AdditionalProgramCard';
import * as S from './styles';

const AdditionalProgramCardList = styled('div')({
    display: 'flex',
    flexFlow: 'row wrap',
    margin: '0 -0.5%',
});

interface StateProps {
    programs: AdditionalProgramState[];
}

interface Props extends StateProps, WithTranslation {
    webExclusive?: boolean;
}

enum AdditionalProgramsListTestID {
    Container = 'AdditionalProgramsListTestID.Container',
}

const AdditionalProgramsListContainer: React.SFC<Props> = props => (
    <>
        <S.CardsListHeading>{props.t('dashboard.programs.programsListTitle')}</S.CardsListHeading>
        <AdditionalProgramCardList data-testid={AdditionalProgramsListTestID.Container}>
            {props.programs.map(program => (
                <AdditionalProgramCard
                    key={program.id}
                    programId={program.id}
                    title={program.title}
                    iconUrl={program.iconUrl}
                    webExclusive={props.webExclusive}
                />
            ))}
        </AdditionalProgramCardList>
    </>
);

const mapStateToProps = (state: AppState): StateProps => ({
    programs: getAdditionalPrograms(state),
});

export const AdditionalProgramsList = withTranslation()(
    connect(mapStateToProps)(AdditionalProgramsListContainer),
);
